import { Component } from '@angular/core';

@Component({
  templateUrl: '401.component.html'
})
export class P401Component {

  constructor() { }

}



// WEBPACK FOOTER //
// /app/src/app/views/pages/401.component.ts